import { render, staticRenderFns } from "./ContactModalForm.vue?vue&type=template&id=f4471468"
import script from "./ContactModalForm.vue?vue&type=script&lang=js"
export * from "./ContactModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports